/* Fichier d'impression Gelato des affiches encadrées (designs) : au moment de l'ajout au panier, les calques
   personnalisés (prénom, date, ville, phrase) sont dessinés à la taille d'impression et envoyés au relais,
   qui crée ensuite le brouillon Gelato. Si l'envoi échoue, la vente passe et la boutique reçoit une alerte. */
(function () {
  var el = document.querySelector('[data-print-config]');
  if (!el) return;
  var cfg; try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  var FRAMES = { 'noir': 'black', 'black': 'black', 'blanc': 'white', 'white': 'white', 'chêne': 'natural-wood', 'chene': 'natural-wood', 'oak': 'natural-wood' };

  function val(form, names) {
    for (var i = 0; i < names.length; i++) {
      var f = form.querySelector('[name="properties[' + names[i] + ']"]');
      if (f && (f.type !== 'checkbox' && f.type !== 'radio' || f.checked)) return f.value || '';
    }
    return '';
  }
  function hidden(form, name, value) {
    var f = form.querySelector('input[type="hidden"][name="properties[' + name + ']"]');
    if (!f) { f = document.createElement('input'); f.type = 'hidden'; f.name = 'properties[' + name + ']'; form.appendChild(f); }
    f.value = value;
  }
  function toBlob(c) { return new Promise(function (res) { c.toBlob(res, 'image/png'); }); }

  function upload(HD, fmt, raw, showTitle) {
    return HD.fontsReady(cfg.fonts).catch(function () {}).then(function () {
      var inf = HD.info(cfg.design, fmt);
      var built = HD.build(cfg.design, fmt, raw, inf.W, { locale: cfg.locale, showTitle: showTitle });
      var fd = new FormData();
      fd.append('meta', JSON.stringify({ design: cfg.design, format: fmt, layers: built.layers.map(function (l) {
        return { top: l.top, left: l.left, w: l.w, h: l.h, stretch: l.canvas.width !== l.w || l.canvas.height !== l.h };
      }) }));
      var chain = Promise.resolve();
      built.layers.forEach(function (l, i) {
        chain = chain.then(function () { return toBlob(l.canvas); }).then(function (b) { fd.append('layer' + i, b, 'layer' + i + '.png'); });
      });
      return chain.then(function () { return fetch(cfg.uploadUrl + '/layers', { method: 'POST', body: fd }); })
        .then(function (r) { if (!r.ok) throw new Error('upload'); return r.json(); });
    });
  }

  /* Écoute en phase de bouillonnement : la validation de product-form.js / orbes.js passe d'abord. */
  document.addEventListener('submit', function (e) {
    var form = e.target, fid = form && form.getAttribute && form.getAttribute('id'); /* form.id est masqué par <input name="id"> */
    if (!form || (fid !== 'ProductForm' && fid !== 'OrbesForm') || e.defaultPrevented || form.dataset.printReady === '1') return;
    var idInput = form.querySelector('[name="id"]'), v = idInput && cfg.variants[idInput.value];
    if (!v) return;
    var frame = FRAMES[String(v.frame || '').toLowerCase()] || '';
    e.preventDefault();
    hidden(form, '_support', v.frame ? 'framed' : 'poster_unframed');
    if (v.frame) hidden(form, '_frame', frame);
    hidden(form, '_design', cfg.design);
    hidden(form, '_format', v.fmt);
    var go = function () { form.dataset.printReady = '1'; form.submit(); };
    var HD = window.CelestiarHD;
    if (!HD || !HD.DESIGNS[cfg.design]) { go(); return; }
    var raw = { prenom: val(form, ['Prénom']), ville: val(form, ['Ville', 'Lieu']), date: val(form, ['Date']), heure: val(form, ['Heure']), phrase: val(form, ['Phrase']) };
    var t = val(form, ['Titre en haut', 'Nom de la perle en haut']);
    var showTitle = !/^(non|no|sans)/i.test(String(t).trim());
    upload(HD, v.fmt, raw, showTitle)
      .then(function (up) { if (up && up.id) hidden(form, '_hd_layer', up.id); })
      .catch(function () {})
      .then(go);
  });
})();
